import { GA4Event} from "./GA4Event";

export function buildProceedToCheckout(message) {
	const { attributes } = message;
	const { eventData } = new GA4Event("proceed_to_checkout", {
		items_in_box: attributes.items_in_box || '',
		interaction: attributes.interaction || '',
		total_rebuy_price: attributes.total_rebuy_price || '',
		has_rejected_items: attributes.has_rejected_items || '',
		currency: attributes.currency || '',
		component: attributes.component || '',
		versandbox_id: attributes.versandbox_id || '',
	});
	return eventData;
}
